import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Process } from "@/components/site/Process";
import { About } from "@/components/site/About";
import { Founder } from "@/components/site/Founder";
import { Fees } from "@/components/site/Fees";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    document.title = "S & H | Automotive Acquisition Group";
  }, []);

  return (
    <div className="App bg-ivory text-ink font-body antialiased">
      <Header />
      <main>
        <Hero />
        <Process />
        <About />
        <Founder />
        <Fees />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
